import shuffle from 'lodash/shuffle';
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { getLabels } from '@Pages/QuickSearch/QuickSearchActions';

const wrapWithStaticExamples = (Component) => {
  function WithStaticExamplesHOC(props) {
    const { inputValue } = props;
    const [currentLabel, setCurrentLabel] = useState(-1);
    const [labels, setLabels] = useState([]);

    useEffect(() => {
      getLabels()
        .then((data) => {
          setLabels(shuffle(data));
        })
        .catch(Logger.error);
    }, []);

    useEffect(() => {
      if (labels.length && !inputValue) {
        setCurrentLabel(currentLabel >= labels.length - 1 ? 0 : currentLabel + 1);
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [inputValue, labels]);

    const placeholder = labels[currentLabel] && `${labels[currentLabel].prefix} ${labels[currentLabel].suffix}`;

    return <Component {...props} placeholder={placeholder} />;
  }

  WithStaticExamplesHOC.propTypes = {
    inputValue: PropTypes.string,
  };

  return WithStaticExamplesHOC;
};

export default wrapWithStaticExamples;
